/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Quantity_Auto_HintInputs */

const vi_lot_items_quantity_auto_hint = /** @type {(inputs: Lot_Items_Quantity_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tự động = tổng KL từ nguồn đơn mua`)
};

/**

* @param {Lot_Items_Quantity_Auto_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_quantity_auto_hint = /** @type {((inputs?: Lot_Items_Quantity_Auto_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Quantity_Auto_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_quantity_auto_hint(inputs)
});